module.exports = __webpack_public_path__ + "media/icons/osoba-prywatna-active@2x-ad001bb6.png";